import React, { memo, SVGProps } from 'react'

export const Plus = memo((props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.5 12.317C4.5 11.9028 4.83579 11.567 5.25 11.567H18.75C19.1642 11.567 19.5 11.9028 19.5 12.317C19.5 12.7312 19.1642 13.067 18.75 13.067H5.25C4.83579 13.067 4.5 12.7312 4.5 12.317Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 4.81702C12.4142 4.81702 12.75 5.1528 12.75 5.56702L12.75 19.067C12.75 19.4812 12.4142 19.817 12 19.817C11.5858 19.817 11.25 19.4812 11.25 19.067L11.25 5.56702C11.25 5.1528 11.5858 4.81702 12 4.81702Z"
      fill="currentColor"
    />
  </svg>
))
